// src/components/dashboard/cases/newCase/case_id/caseTable/stlViewerSession.js
//
// Persists per-file STL viewer state to sessionStorage so a page reload
// restores: sidebar toggles, opacity, clipping plane, measurements,
// camera orientation, etc. sessionStorage (not localStorage) is used
// because this state is only meaningful within the current tab/session.

const STORAGE_KEY = "stlViewer.session.v1";
const MODAL_KEY = "stlViewer.openFile.v1";

const safeParse = (raw) => {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const readAll = () => {
  if (typeof sessionStorage === "undefined") return {};
  return safeParse(sessionStorage.getItem(STORAGE_KEY)) || {};
};

const writeAll = (all) => {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    /* quota — ignore */
  }
};

export const loadViewerState = (fileUrl) => {
  if (!fileUrl) return null;
  const all = readAll();
  return all[fileUrl] || null;
};

export const saveViewerState = (fileUrl, state) => {
  if (!fileUrl) return;
  const all = readAll();
  all[fileUrl] = { ...state, savedAt: Date.now() };
  writeAll(all);
};

export const clearViewerState = (fileUrl) => {
  if (!fileUrl) return;
  const all = readAll();
  if (all[fileUrl]) {
    delete all[fileUrl];
    writeAll(all);
  }
};

// ---- Modal open/close persistence ----
export const saveOpenModalFileId = (fileId) => {
  if (typeof sessionStorage === "undefined") return;
  try {
    if (fileId == null) sessionStorage.removeItem(MODAL_KEY);
    else sessionStorage.setItem(MODAL_KEY, String(fileId));
  } catch {
    /* ignore */
  }
};

export const loadOpenModalFileId = () => {
  if (typeof sessionStorage === "undefined") return null;
  try {
    return sessionStorage.getItem(MODAL_KEY);
  } catch {
    return null;
  }
};